import { lazy } from "react";

const PanamaCanal = lazy(() => import("./PanamaCanal"));
const AiCanda = lazy(() => import("./AiCanda"));
const EconomicOutlook = lazy(() => import("./EconomicOutlook"));
const DominicanRepublic = lazy(() => import("./domicanRepublic"));
const MexicoGrowth = lazy(() => import("./MexicoGrowth"));
const Epocket = lazy(() => import("./epocket"));
const GhanaEconomy = lazy(() => import("./GhanaEconomy"));
const NigeriaEconomy = lazy(() => import("./NigeriaEconomy"));
const SouthAfricaEconomy = lazy(() => import("./SouthAfricaEconomy"));
const Melbourne = lazy(() => import("./Melbourne"));
export {
  PanamaCanal,
  AiCanda,
  EconomicOutlook,
  DominicanRepublic,
  MexicoGrowth,
  Epocket,
  GhanaEconomy,
  NigeriaEconomy,
  SouthAfricaEconomy,
  Melbourne,
};
